<template>
  <div>
    <v-card-title class="d-flex justify-center align-center mb-n7">
      <strong>
        {{ $t('guest.capacity.availability-status') }}
      </strong>
    </v-card-title>
    <Capacity></Capacity>
    <v-card-text>
      <span v-for="(text, index) in $t('guest.capacity.availability-info')" :key="index">
        {{ text }}<br>
      </span>
    </v-card-text>
    <v-row align="center" justify="center">
      <router-link to="/auth/guest-login">
        <v-btn color="Main_0003" class="ma-5" min-width="300">
          <span class="white--text">
            <strong>
              {{ $t('guest.capacity.proceed-to-reservation') }}
            </strong>
          </span>
        </v-btn>
      </router-link>
    </v-row>
    <v-row align="center" justify="center">
      <router-link to="/auth/guest-login">
        <v-btn outlined color="Main_0003" class="ma-5" min-width="300">
          <span class="Main_0003--text">
            <strong>
              {{ $t('guest.capacity.first-time-users') }}
            </strong>
          </span>
        </v-btn>
      </router-link>
    </v-row>
  </div>
</template>

<script>
import Capacity from "@/resources/components/guest/capacity.component.vue";
export default {
  components: {
      Capacity,
  },
}
</script>
